<header class="platform-header">
  <div class="logo">
    <a [routerLink]="['/']" class="logo" slot="logoBar">
      <img
        [ngSrc]="MARKANT_LOGO_PATH"
        alt="Markant logo"
        width="133"
        height="30"
        priority
      />
    </a>
  </div>

  <markant-platform-header-navigation
    class="navigation"
    slot="toolBar"
    [routes]="(visibleRoutes$ | async) ?? []"
    [activeIndex]="(activeTabIndex$ | async) ?? 0"
  >
  </markant-platform-header-navigation>

  <div class="actions">
    <markant-platform-language-selection></markant-platform-language-selection>
    <markant-platform-user-notifications></markant-platform-user-notifications>
    <markant-platform-user-menu class="user-icon"></markant-platform-user-menu>
    <markant-platform-mobile-menu
      class="mobile-menu"
      [routes]="(visibleRoutes$ | async) ?? []"
    >
    </markant-platform-mobile-menu>
  </div>
</header>
